import { useEffect } from "react";

// Google Analytics 4 measurement id
const GA_MEASUREMENT_ID = "G-66VBCKD1ZB";

// Module scope: gtag.js must be loaded and configured only once per visit,
// even if the visitor leaves the home page and comes back to it.
let analyticsLoaded = false;

/**
 * Loads the Google tag (gtag.js) once.
 * It is rendered only by the pages that should be tracked (currently the home
 * page), so all the other routes stay untouched.
 *
 * Same logic as the snippet Google generates, except that the tag falls back to
 * <head> when the document has no <script> yet.
 */
const GoogleAnalytics = () => {
    useEffect(() => {
        if (analyticsLoaded) {
            return;
        }
        analyticsLoaded = true;

        // queue the calls that happen before gtag.js loads (official snippet)
        window.dataLayer = window.dataLayer || [];
        window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };

        const tag = document.createElement("script");
        tag.async = true;
        tag.src = "https://www.googletagmanager.com/gtag/js?id=" + GA_MEASUREMENT_ID;

        const firstScript = document.getElementsByTagName("script")[0];
        if (firstScript && firstScript.parentNode) {
            firstScript.parentNode.insertBefore(tag, firstScript);
        } else {
            document.head.appendChild(tag);
        }

        window.gtag("js", new Date());
        window.gtag("config", GA_MEASUREMENT_ID);
    }, []);

    return null;
};

export default GoogleAnalytics;
